<template>
  <nav class="mt-2 nav-flat">
    <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" data-accordion="true" role="menu">
      <!-- Add icons to the links using the .nav-icon class
                                                                                                       with font-awesome or any other icon font library -->
      <li class="nav-item">
        <router-link :to="{ name: 'admin_dashboard' }" class="nav-link " v-if="canAccessAdminSection">
          <i class="fas fa-database nav-icon"></i>
          <p>Admin</p>
        </router-link>
        <router-link :to="{ name: 'home' }" class="nav-link ">
          <i class="fas fa-database nav-icon"></i>
          <p>Aziende</p>
        </router-link>
      </li>
    </ul>
    <div class="app-version">
      v. {{appVersion}}
    </div>
  </nav>
</template>

<script setup>
import {mapState} from 'pinia';
import {inject} from 'vue';
import { CORE_USER_PERMISSIONS as CUP } from '@/enums/CoreUserPermissions';

const userCan = inject('userCan');
const canAccessAdminSection = (
  userCan(CUP.MANAGE_USERS)
  || userCan(CUP.MANAGE_ACCOUNTS)
  || userCan(CUP.MANAGE_COMPANIES)
  || userCan(CUP.MANAGE_GROUPS)
  || userCan(CUP.MANAGE_OAUTHAPPS)
  || userCan(CUP.VIEW_LOGS)
);
const appVersion = APP_VERSION;
</script>

<style>
.app-version {
  position: fixed;
  line-height: 1em;
  bottom: 0px;
  left: 0px;
  padding: 10px;
}

/* Search global.scss for ".sidebar-open .main-sidebar" for context */
@media (max-width: 767.98px) {
  .app-version {
    margin-left: -250px;
  }

  .sidebar-open .app-version {
    margin-left: 0px;
  }
}
</style>
